import React from 'react';
import Avatar from '@mui/material/Avatar';
import Props from '../../types/props';

function ProfileAvtaar({ ...props }: Props) {
  return <Avatar src={props.src} alt={props.alt} sx={props.style} />;
}

export default ProfileAvtaar;
